import type { Plugin } from "svelte-exmarkdown";

export const blogPreviewPlugin: Plugin = { renderer: {} };
export const blogPlugin: Plugin = { renderer: {} };